import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { NavItem, Nav } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import { RouteUrls } from '../configs/routeUrls';
import { SelectOptions } from './SelectOptions';
import { LogOn } from './LogOn';
import { ShowInMikolow } from '../configs/globals';

export class Header extends Component {
	render() {
		const { applicationImages, officeFooter } = this.props;

		return (
			<div className="header-shadow">
				<header className="header container">
					<a
						className="header__logo"
						href={officeFooter.eboi ? officeFooter.eboi : '/'}
						title="Przejdź do strony głównej"
					>
						{applicationImages && (
							<img
								className="header__image"
								src={`data:${applicationImages.logoContentType};base64,${applicationImages.logo}`}
								alt="Logo"
								title="Logo"
							/>
						)}
					</a>
					<div className="header__right">
						{this.props.offices &&
						this.props.offices.length > 1 && (
							<SelectOptions
								className="header__departments-select"
								label="Instytucja"
								items={this.props.offices}
							/>
						)}
						<div className="header__right-right">
							<NavItem className="text-nowrap">
								{this.props.isAuth == false &&
								!ShowInMikolow && (
									<NavLink
										className="button button--primary-dark button--width-auto"
										to={RouteUrls.App.login}
									>
										Zaloguj się
									</NavLink>
								)}
								{this.props.isAuth == false &&
								ShowInMikolow && (
									<Nav.Link
										className="button button--primary-dark button--width-auto"
										href={this.props.externalSystemAddress}
									>
										Zaloguj się
									</Nav.Link>
								)}
								{this.props.isAuth && (
									<LogOn
										label={this.props.loginName}
										className="header__user"
										onLogout={this.props.logoutUser}
									/>
								)}
							</NavItem>
						</div>
					</div>
				</header>
			</div>
		);
	}
}

Header.propTypes = {
	externalSystemAddress: PropTypes.string,
	offices: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.number,
			name: PropTypes.string
		})
	),
	officeFooter: PropTypes.any
};

Header.defaultProps = {
	externalSystemAddress: '#',
	offices: [],
	officeFooter: { name: '' }
};

// <Container>
// <Navbar collapseOnSelect expand="lg" variant="light" className="navbar bg-light justify-content-between">
//   <NavbarBrand className="navbar-brand col-sm-3 col-md-2 mr-0" to={RouteUrls.App.main}>Logotyp </NavbarBrand>
//   <Nav className="justify-content-end">
// 	<NavItem className="text-nowrap">
// 		{ this.props.isAuth == false && (<NavLink className="nav-link" to={RouteUrls.App.login}>
// 		  Zaloguj
// 		</NavLink>
// 		)}
// 		{this.props.isAuth && (<NavDropdown title={this.props.loginName} id="basic-nav-dropdown">
// 			<NavDropdown.Item href="/ustawienia-konta">Ustawienia konta</NavDropdown.Item>
// 			<NavDropdown.Divider />
// 			<NavDropdown.Item href="/wyloguj">Wyloguj</NavDropdown.Item>
// 		  </NavDropdown>
// 		)}
// 	</NavItem>
//   </Nav>
// </Navbar>
// </Container>
